<template>
  <div class="uploader">
    <!-- <el-scrollbar class="app-scrollbar"> -->
    <!-- <div class="title">请选择文件</div> -->
    <div class="bg upload">
      <el-upload
        class="upload-demo"
        :action="signature.host"
        :before-upload="beforeUpload"
        :on-success="uploadSuccess"
        :show-file-list="false"
        :data="requestBody"
        :file-list="fileList"
      >
        <el-button size="small" type="primary" plain>上传附件</el-button>
      </el-upload>
    </div>
    <div
      v-for="item in imageList"
      :key="item.url"
      :class="['bg', { nopicture: item.url === '' }]"
    >
      <span class="imageWarpper">
        <!-- <img :src="item.url" alt v-if='item.type==="image"'/> -->
        <a :href="item.url" target="_blank">{{ item.name }}</a>
        <i class="el-icon-close closeIcon" @click="removeFiles"></i>
      </span>
    </div>
    <!-- </el-scrollbar> -->
  </div>
</template>
<script>
import { getFiles, signature as signatures } from "@/api/files";
import { signature } from "@/api/street";
// import SurveyPreview from './components/survey-preview'
import moment from "moment";
// import bgs from './imgs'
export default {
  props: ["scene"],
  data() {
    return {
      file: {},
      files: [],
      signature: {
        host: "",
      },
      fileList: [],
      imageList: [],
      requestBody: {},
    };
  },
  computed: {
    surveyBody() {
      return this.$store.state.survey.surveyBody;
    },
  },
  mounted() {
    // this.getFiles();
    this.aliossSignature();
  },
  methods: {
    aliossSignature() {
      if (this.scene == "points") {
        signatures({
          bucket: "private",
          scene: this.scene,
        }).then((response) => {
          this.signature = response.data || {};
          this.requestBody = {
            policy: this.signature.policy,
            OSSAccessKeyId: this.signature.access_id,
            success_action_status: 200,
            signature: this.signature.signature,
            callback: this.signature.callback,
          };
        });
      } else {
        signature({
          bucket: "private",
          scene: this.scene,
        }).then((response) => {
          this.signature = response.data || {};
          this.requestBody = {
            policy: this.signature.policy,
            OSSAccessKeyId: this.signature.access_id,
            success_action_status: 200,
            signature: this.signature.signature,
            callback: this.signature.callback,
          };
        });
      }
    },
    beforeUpload(file) {
      const url = file.name;
      const index = url.lastIndexOf(".");
      const suffix = url.substring(index + 1, url.length).toLowerCase();
      this.$set(
        this.requestBody,
        "key",
        this.signature.dir + moment().format("YYYYMMDD_HHmmss") + `.${suffix}`
      );
      //   if (type.indexOf(suffix) >= 0) {
      //   }

      //   else {
      //     this.$message({
      //       type: "error",
      //       message: "请上传指定类型的文件",
      //       center: true,
      //       duration: 1500,
      //     });
      //     return false;
      //   }
    },
    removeFiles(index) {
      this.fileList.splice(index, 1);
      this.imageList.splice(index, 1);
      this.$emit("uploadRemove", index);
    },
    // 成功上传后，从数据库中获取文件列表
    uploadSuccess(response, file, fileList) {
      if (response.Status === "Ok") {
        this.imageList = fileList.map((item) => ({
          url: URL.createObjectURL(item.raw),
          type: /.(png|jpg|jpeg|gif)$/g.test(item.name) ? "image" : "file",
          name: item.name,
        }));
        this.$emit("uploadSuccess", this.requestBody);
        this.$message({
          type: "success",
          message: "上传成功",
          center: true,
          duration: 1500,
        });
      } else {
        this.$message({
          type: "error",
          message: "网络故障请从新上传",
          center: true,
          duration: 1500,
        });
      }

      //   this.getFiles();
    },
    setCurrentBg(bg) {
      this.surveyBody.head_img = bg.url;
      this.currentBg = bg;
    },
    // 调用获取文件 api
    getFiles() {
      getFiles({
        scene: this.scene,
      }).then((response) => {
        this.files = response.data;
      });
    },
  },
  components: {
    // SurveyPreview,
  },
};
</script>
<style lang="less" scoped>
// @import "./upload-file.less";
.uploader {
  padding: 10px 0;
}
</style>
